import React from "react";

export const DownloadIcon = React.memo(() => {
    return (
        <svg style={{minWidth: 20}} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5 3H12.3333V8.5H14.625L10.5 12.625M10.5 3H8.66667V8.5H6.375L10.5 12.625" stroke="var(--messenger-blue)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5 16.75H16" stroke="var(--messenger-blue)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
});